import { Form } from "react-bootstrap";

export const RadioEinwilligung = (props) => {
  const { value, onChange, error } = props || {};
  return (
    <Form.Group className="mb-one">
      <Form.Check type="radio" id="radio-einwilligung-1" className="mb-one">
        <Form.Check.Input
          type="radio"
          name="einwilligung-radio"
          value="option1"
          checked={value === "option1"}
          onChange={() => onChange("option1")}
          isInvalid={!!error}
        />
        <Form.Check.Label className={"f-small" + (error ? " is-invalid" : "") + " text-black fw-bold form-check-label ps-one-half"}>
          Ich handle im eigenen wirtschaftlichen Interesse und nicht auf fremde Veranlassung (insbesondere nicht als Treuhänder).
        </Form.Check.Label>
      </Form.Check>
      <Form.Check type="radio" id="radio-einwilligung-2" className="mb-one">
        <Form.Check.Input
          type="radio"
          name="einwilligung-radio"
          value="option2"
          checked={value === "option2"}
          onChange={() => onChange("option2")}
          isInvalid={!!error}
        />
        <Form.Check.Label className={"f-small" + (error ? " is-invalid" : "") + " text-black fw-bold form-check-label ps-one-half"}>
          Ich handle auf fremde Veranlassung (z.B. als Treuhänder) – die erforderliche Dokumentation zur Legitimation des wirtschaftlich Berechtigten (z.B. Treugeber) liegt dem Institut vor.
        </Form.Check.Label>
      </Form.Check>
      {error && (
        <div className="ui error message text-danger f-small">
          <div className="header">Bitte eine Option auswählen</div>
        </div>
      )}
    </Form.Group>
  );
};
